<template>
  <Modal :open="isOpen"
    dark
    @close="$emit('close')">

    <template #header>
      <h2 class="modal-title">Võta meiega ühendust</h2>
      <p class="modal-desc">
        Vajad hinnapakkumist või on küsimusi? <br>
        Kirjuta meile ja vastame 24 tunni jooksul.
      </p>

      <div class="modal-info">
        <div class="modal-info-item">
          <div class="modal-icon"><i class="fa-solid fa-phone" /></div>
          <div>
            <strong>Telefon</strong>
            <a href="tel:+37253311191">+372 5331 1191</a>
          </div>
        </div>
        <div class="modal-info-item">
          <div class="modal-icon"><i class="fa-solid fa-envelope" /></div>
          <div>
            <strong>E-post</strong>
            <a href="mailto:info@aktuaalne.ee">info@aktuaalne.ee</a>
          </div>
        </div>
        <div class="modal-info-item">
          <div class="modal-icon"><i class="fa-solid fa-location-dot" /></div>
          <div>
            <strong>Asukoht</strong>
            <span>Võru, Eesti</span>
          </div>
        </div>
      </div>
    </template>

    <ContactForm :selected-service="service" />
  </Modal>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'contact-modal',
  components: { ContactForm },
  emits: ['close'],
  props: {
    isOpen: { type: Boolean, default: false },
    service: { type: [String, Number], default: '' }
  }
}
</script>

<style lang="scss" scoped>
.modal-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14rem;

  @include max-screen(480) {
    grid-template-columns: 1fr;
  }
}

.modal-info-item {
  display: flex;
  align-items: center;
  gap: 14rem;

  strong {
    display: block;
    font-size: 13rem;
    font-weight: 600;
  }

  span,
  a {
    font-size: 14rem;
    text-decoration: none;
  }
}
</style>
